<div class="lista-ficha-content">
  <app-ficha-table [propostas]="propostas" [idFase]="4" [filtro]="filtro"></app-ficha-table>
  <div *ngIf="propostas.length === 0">
    <h2>Não foram encontradas propostas para essa fase</h2>
  </div>
</div>
